import { Accession } from "pwapi";

import { LIS } from "shared/actions/constants";
import { PWAction } from "shared/utils/redux";

export type AccessionState =
  | (Accession & {
      field_meta?: {
        billing_type?: { value?: string; disabled?: boolean };
        bill_tc?: { value?: boolean; disabled?: boolean };
        bill_pc?: { value?: boolean; disabled?: boolean };
      } | null;
      remains_digital_pc?: boolean;
    })
  | null;

const accessionReducer = (
  state: AccessionState = null,
  action: PWAction
): AccessionState => {
  switch (action.type) {
    case LIS.ACCESSION.GET.SUCCESS:
    case LIS.ACCESSION.CREATE.SUCCESS:
    case LIS.ACCESSION.UPDATE.SUCCESS:
    case LIS.ACCESSION.PRINT.SUCCESS:
      const { created_case: _, _meta, ...remaining } = action.payload.response;
      return remaining;
    case LIS.ACCESSION.DELETE.SUCCESS:
      return state?.id === action.args.id ? null : state;
    default:
      return state;
  }
};

export default accessionReducer;
